import React, { FC, ReactNode } from 'react'

export interface ContentCardProps {
    children: ReactNode
    style?: React.CSSProperties
}

const BackgroundContentCard: FC<ContentCardProps> = ({ children, style = {} }) => {
    return (
        <div style={{
            backgroundColor: '#f7f9fc',
            padding: '24px',
            borderRadius: '8px',
            border: '1px solid #d3dae6',
            height: '100%',
            ...style
        }}>
            {children}
        </div>
    )
}

export default BackgroundContentCard;